export default __webpack_public_path__ + "static/media/640_dummy2016-hilfsprojekt01-de-mobile.000e63f7.png";